export class PanelCallEpisodeStruct {
    public idEpisode: number;
    public patientName: string;
    public patientSocialName: string;
    public ticketInitials: string;
    public ticketSequence: number;
    public idAttendantUser: number;
    public idStatusQueue: number;
    public attendantUserName: string;
}